<!--
  Renders the Resource - Advisory app route
-->
<template>
  <!-- Blog Post Type -->
  <div class="row cis-resource-advisory">
    <!-- Inline styles to position the image in upper right corner -->
    <div data-e2e-id="cis-resource-advisory" class="col-lg-12 col-md-12 col-sm-12 template-content">
      <!-- Main Content -->
      <div class="col-lg-9 col-md-9 col-sm-12 template-main-content">
        <!-- Title -->
        <h1
          v-if="routeData.fields.resourceTitle && routeData.fields.resourceTitle.value.length > 0"
        >
          <sc-text :field="routeData.fields.resourceTitle" />
        </h1>

        <!-- MS-ISAC ADVISORY NUMBER -->
        <div
          v-if="routeData.fields.advisoryNumber && routeData.fields.advisoryNumber.value.length > 0"
        >
          <h4>MS-ISAC ADVISORY NUMBER:</h4>
          <sc-text tag="span" class="advisory-number" :field="routeData.fields.advisoryNumber" />
        </div>

        <!-- DATE(S) ISSUED -->
        <div
          v-if="
            routeData.fields.dateIssued &&
            routeData.fields.dateIssued.value.length > 0 &&
            routeData.fields.dateIssued.value !== '0001-01-01T00:00:00Z'
          "
        >
          <h4>DATE(S) ISSUED:</h4>
          <span v-if="routeData.fields && routeData.fields.dateIssued" class="advisory-date-issued">
            {{
              routeData.fields.dateIssued.value.substring(7, 5) +
              '/' +
              routeData.fields.dateIssued.value.substring(10, 8) +
              '/' +
              routeData.fields.dateIssued.value.substring(4, 0)
            }}
          </span>
        </div>

        <!-- OVERVIEW -->
        <div v-if="routeData.fields.overview && routeData.fields.overview.value.length > 0">
          <h4>OVERVIEW:</h4>
          <sc-rich-text :field="routeData.fields.overview" />
        </div>

        <!-- THREAT INTELLIGENCE -->
        <div
          v-if="
            routeData.fields.threatIntelligence &&
            routeData.fields.threatIntelligence.value.length > 0
          "
        >
          <h4>THREAT INTELLIGENCE:</h4>
          <sc-rich-text :field="routeData.fields.threatIntelligence" />
        </div>

        <!-- SYSTEMS AFFECTED -->
        <div v-if="routeData.fields.affectedSystems && routeData.fields.affectedSystems.length > 0">
          <h4>SYSTEMS AFFECTED:</h4>
          <resource-advisory-affected-system v-bind:items="routeData.fields.affectedSystems" />
        </div>

        <!-- RISK -->
        <div v-if="routeData.fields.riskCategories && routeData.fields.riskCategories.length > 0">
          <h4>RISK:</h4>
          <resource-advisory-risk-category v-bind:items="routeData.fields.riskCategories" />
        </div>

        <!-- TECHNICAL SUMMARY -->
        <div
          v-if="
            routeData.fields.technicalSummary && routeData.fields.technicalSummary.value.length > 0
          "
        >
          <h4>TECHNICAL SUMMARY:</h4>
          <sc-rich-text :field="routeData.fields.technicalSummary" />
        </div>

        <!-- RECOMMENDATIONS -->
        <div
          v-if="routeData.fields.recommendation && routeData.fields.recommendation.value.length > 0"
        >
          <h4>RECOMMENDATIONS:</h4>
          <sc-rich-text :field="routeData.fields.recommendation" />
        </div>

        <!-- REFERENCES -->
        <div v-if="routeData.fields.references && routeData.fields.references.length > 0">
          <h4>REFERENCES:</h4>
          <resource-advisory-reference v-bind:items="routeData.fields.references" />
        </div>
      </div>
      <!-- Right Rail -->
      <div class="col-lg-3 col-md-3 col-sm-12 template-sidebar" :class="{ addShadow: isContent }">
        <h4>Get Email Updates When Cyber Threats Like This Arise</h4>

        <a href="https://learn.cisecurity.org/ms-isac-subscription" class="c-cta--primary">
          Subscribe to Advisories
        </a>

        <related-resource v-bind:fields="routeData.fields" />
      </div>
    </div>
  </div>
</template>

<script>
import ResourceAdvisoryAffectedSystem from './CIS-Resource-Advisory-AffectedSystem.vue';
import ResourceAdvisoryReference from './CIS-Resource-Advisory-Reference.vue';
import ResourceAdvisoryRiskCategory from './CIS-Resource-Advisory-RiskCategory.vue';
import { Text, RichText } from '@sitecore-jss/sitecore-jss-vue';
import RelatedResource from './CIS-ResourceRelatedResources.vue';

export default {
  name: 'CIS-Resource-Advisory',
  props: {
    fields: {
      type: Object
    },
    rendering: {
      type: Object
    }
  },
  components: {
    ScText: Text,
    ScRichText: RichText,
    ResourceAdvisoryAffectedSystem,
    ResourceAdvisoryReference,
    ResourceAdvisoryRiskCategory,
    RelatedResource
  },
  data: function () {
    return {
      isContent: false
    };
  },
  computed: {
    routeData() {
      // this.$jss is defined on the Vue instance by the SitecoreJssPlugin and provides
      // reactive access to the root level route data provided in layout service data.
      return this.$jss.routeData();
    }
  },
  mounted() {
    if (window.innerWidth <= 991) {
      if (document.querySelector('.template-sidebar')) {
        var sideBar = document.querySelector('.template-sidebar').innerHTML;
        var newSideBar = sideBar.replace(new RegExp('<!---->', 'g'), '');

        if (newSideBar != '') {
          this.isContent = true;
        }
      }
    }
  }
};
</script>
<style lang="scss">
.cis-resource-advisory {
  h4 {
    font-size: 2rem;
  }

  h5 {
    font-size: 1.8rem;
  }
}
</style>
